import { reducer } from 'redux-form';
import moment from 'moment';


export default reducer.normalize({
  createBooking: {
    dateString: value => value && value.toUpperCase(),
    bookingYear: (value, previousValue, allValues) => {
      const { dateString } = allValues;
      if (dateString && /^\d{1,2}\w{3}-\d+NT/i.test(dateString)) {
        const [date] = dateString.split('-');
        const bookingDate = moment(date, 'DDMMM').startOf('day');
        if (bookingDate && bookingDate.isValid()) {
          if (bookingDate < moment().startOf('day')) {
            value = bookingDate.year() + 1;
          }
        }
      }

      return value;
    },
  },
});



// WEBPACK FOOTER //
// /src/store/reducers/formReducer.js